// package: report
// file: report/model.proto


export const Item = {
    encode(object) {
        const message = {};
        if (object.fields != null) {
            if (typeof object.fields !== "object") {
                throw TypeError("fields: object expected");
            }
            const keys = Object.keys(object.fields);
            if (keys.length > 0) {
                message.fields = {};
                for (let i = 0; i < keys.length; ++i) {
                    if (object.fields[keys[i]] !== "") {
                        message.fields[keys[i]] = String(object.fields[keys[i]]);
                    }
                }
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            fields: {},
        };

        if (message.fields != null) {
            const keys = Object.keys(message.fields);
            object.fields = {};
            for (let i = 0; i < keys.length; ++i) {
                    object.fields[keys[i]] = message.fields[keys[i]];
            }
        }
        return object;
    },
};


